import React from 'react';
var mobileBreakpoint = 800;
export const initPage = () => {
  
}



// WEBPACK FOOTER //
// ./src/utils/utilities.js